import { BaseModel } from "../base.model"; 

export interface Tenant extends BaseModel {
    name?: string
    desabled?: boolean
    defaultSchema?: boolean
    status?: string
}

export const defaultTenant: Readonly<Tenant> = {};